import React from 'react';
import MessageDetails from './MessageDetails';
import MessagesList from './MessagesList';

const Messages = () => {
    return (
        <div className="flex flex-col gap-0 bg-custom-bg-purple w-full flex-1 h-full min-h-0 max-w-full">
            {/* Header */}
            <div className="pl-fluid-2 rounded-xl w-fit">
                <h4 className="text-fluid-lg font-semibold mt-2">
                    Messages Overview
                </h4>
                </div>


            <div className="fluid-0.5 flex flex-col  flex-1 min-h-0 overflow-hidden">

        {/*  Fixed: Make MessagesList take necessary space */}
        <MessagesList />

        {/*  Fixed: Ensure MessagesDetails doesn't add unnecessary margin */}
        <div className="flex-1 overflow-auto">
  <MessageDetails />
</div>
      </div>
        </div>
        
    );
};

export default Messages;